import Button from './button';
import ButtonGroup from './button-group';
Button.Group = ButtonGroup;
export default Button;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/button/index.js
// module id = 63
// module chunks = 1